import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import React from 'react';
import { TRANSACTIONS_TABLE_COLS } from '../../../../constants/tables';
import { formatDate } from '../../../../helpers/utils';
import Typography from '../Typography';
import theme from '../../../theme';

interface ITransactionsTableProps {
  data: any[];
  className?: string;
}

export default function TransactionsTable({
  data,
  className
}: ITransactionsTableProps) {

  const getTransactionStringStatus = (
    status: string,
  ): string => {
    if (status === 'succeeded') return 'Eseguita';
    if (status === 'failed') return 'Rifiutata';
    return '--';
  }

  return (
    <Table
      removeWrapper
      className={className} 
      isStriped aria-label="Famiglie">
      <TableHeader>
        {TRANSACTIONS_TABLE_COLS.map((c, i) => (
          <TableColumn key={i}>{c}</TableColumn>
        ))}
      </TableHeader>
      <TableBody>
        {
          data.map((transaction, i) => (
            <TableRow key={i}>
              <TableCell>{transaction.created ? formatDate(transaction.created * 1000) : '--'}</TableCell>
              <TableCell>
                <Typography 
                  variant='label'
                  colorVariant={transaction.status === 'succeeded' ? 'success' : 'error'}>
                  {getTransactionStringStatus(transaction.status)}
                </Typography>
              </TableCell>
              <TableCell>{`${((transaction.amount ?? 0) / 100).toFixed(2).replace('.', ',')} €`}</TableCell>
            </TableRow>
          ))
        }
      </TableBody>
    </Table>
  )
}